module.exports = __webpack_public_path__ + "static/duplex-704818d37080ef22589b8c2711c45ddf.jpg";